import { render, staticRenderFns } from "./DutyNotice.vue?vue&type=template&id=d82ec706&"
import script from "./DutyNotice.vue?vue&type=script&lang=js&"
export * from "./DutyNotice.vue?vue&type=script&lang=js&"
import style0 from "./DutyNotice.vue?vue&type=style&index=0&id=d82ec706&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports